import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch, Select } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import ERP from "../../../../../utils/ErpService";

export default function PrvCiudadesForm(props) {
  const { record, closeModal, currentUser, gstregiones, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.ciu_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [region, setRegion] = useState(!record.ciu_id ? "" : record.rgn_id);

  const { Option } = Select;

  useEffect(() => {
    setCurId(record.ciu_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await ERP.sendPrvCiudades(
      currentUser,
      curId,
      region,
      "PrvCiudades",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE CIUDADES",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE CIUDADES",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="PrvCiudades"
      onFinish={guardarCambios}
      initialValues={{
        ciu_nombre: record.ciu_id > 0 ? record.ciu_nombre : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.ciu_id > 0
            ? "ACTUALIZAR CIUDADES"
            : "AGREGAR CIUDADES"}
        </Title>
      </Form.Item>
      <Form.Item
        name="rgn_id"
        label="Region"
        wrapperCol={{ span: 100 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
          <Select
            showSearch
            showArrow
            style={{ width: "200px" }}
            defaultValue={region}
            onChange={(val) => setRegion(val)}
            placeholder="Region"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {gstregiones.map((regiones) => (
              <Option key={regiones.rgn_id} value={regiones.rgn_id}>
                {regiones.rgn_nombre}
              </Option>
            ))}
          </Select>
      </Form.Item>
      <Form.Item
        name="ciu_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.ciu_id > 0 ? record.ciu_nombre : ""}
        />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
